import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  html,body { 
    margin: 0;
    padding: 0;
    box-sizing: border-box;

    -webkit-font-smoothing: antialiased;
  }

  #root {
    min-height: 100vh;
  }

`;
